/* eslint-disable react/jsx-no-bind */
import { IObject } from 'interfaces'
import { picDashboard } from 'assets/Icons'
import { Icon } from 'assets/index'
import { IMAGES } from 'configs/configs.js'
import { AuthContext } from 'context'
import { useRef, useContext, useState, useEffect } from 'react'
import { Form } from '@unform/web'
import { jwtDecode } from 'jwt-decode'
import { useFetch, useStorage } from 'hooks'
import { FileInput } from '..'
import { Label, Div } from './style'

/* eslint-disable spaced-comment */
interface IEditPictureProps {
  name?: string
  revert?: boolean
  onChangeFile?: (_file?: File) => void
}

interface IGreetings {
  name?: string
}

interface IPicture {
  name?: string
  profilePicture?: string
  onChangeFile?: (_file?: File) => void
}

interface IdecodedUser {
  payload: {
    issuer: string
    audience: string
    user: {
      client: string
      key: string
      level: string
      profilePic: any
      sector: string
      status: string
    }
    iat: number
    exp: number
  }
}

const getGreeting = () => {
  const now = new Date()
  const hour = now.getHours()
  if (hour >= 6 && hour < 12) return 'Bom dia,'
  if (hour >= 12 && hour < 18) return 'Boa tarde,'
  return 'Boa noite,'
}

const Greetings = (props: IGreetings) => {
  const { name = 'Anônimo' } = props
  return (
    <div className="greeting-container">
      <span className="greeting">{getGreeting()}</span>
      <span className="user-name">{name}</span>
    </div>
  )
}

const Picture = (props: IPicture) => {
  const formRef = useRef<HTMLFormElement | any>(null)
  const { name = 'Anônimo', profilePicture, onChangeFile } = props

  return (
    <Label htmlFor="editPicture">
      <div className="edit-user-icon">
        <img src={Icon('edit.svg')} alt="edit user icon" />
        <Form ref={formRef} onSubmit={console.log}>
          <FileInput id="editPicture" name={name} onChangeFile={onChangeFile} />
        </Form>
      </div>
      <img className="user-icon" src={profilePicture} alt="user pic" />
    </Label>
  )
}

export default function EditPicture(props: IEditPictureProps) {
  const { revert } = props
  const auth = useContext(AuthContext)
  const api = useFetch()
  const [user, setUser] = useStorage('User')
  // const [user, setUser] = useState<IObject>({})

  // useEffect(() => {
  //   // setUser(auth.user)
  //   console.log('imagem foto', user)
  // }, [auth.user])

  function onSubmitPicture(file?: File) {
    if (!file) return
    const formdata = new FormData()
    formdata.set('profilePicture', file)
    api
      .fetch('put', formdata, '/gestor', {
        'Content-type': 'multipart/form-data',
      })
      .then((res) => {
        // console.log('update foto', res)
        const decodedUser: IdecodedUser = jwtDecode(res.data.token)
        // console.log(decodedUser.payload)
        setUser(decodedUser.payload)
      })
      .catch(console.error)
  }

  function profilePicture() {
    if (user?.profilePic) return `${IMAGES.URL}/images/${user?.profilePic}`
    return picDashboard
  }
  console.log('user:', user)
  console.log('profilePic:', user?.profilePic)
  return (
    <Div {...props}>
      {revert ? (
        <>
          <Greetings name={user?.name} />
          <Picture
            name={user?.name}
            onChangeFile={onSubmitPicture}
            profilePicture={profilePicture()}
          />
        </>
      ) : (
        <>
          <Picture
            name={user?.name}
            onChangeFile={onSubmitPicture}
            profilePicture={profilePicture()}
          />
          <Greetings name={user?.name} />
        </>
      )}
    </Div>
  )
}
